export default __webpack_public_path__ + "static/icon-4fe30c0436ad3a96e61c6bdd794e93ae.png";